import { SxProps, Theme } from '@mui/material';

export const LoginTitleSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-xl)',
	fontWeight: '800',
	letterSpacing: '0px',
	color: '#2C2C2C',
	textTransform: 'uppercase',
	opacity: 1,
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-lg)',
	},
});
